import React, { useState, useEffect, useRef } from "react";

const statsData = [
  { icon: "🔧", number: 1000, suffix: "+", label: "TVs Repaired" },
  { icon: "⭐", number: 4.8, suffix: "/5", label: "Average Rating", isDecimal: true },
  { icon: "📅", number: 10, suffix: "+", label: "Years Experience" },
  { icon: "😊", number: 100, suffix: "%", label: "Satisfaction" },
];

const AnimatedNumber = ({ target, suffix, isDecimal, isVisible }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(current);
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [isVisible, target]);

  return (
    <span className="stat-number">
      {isDecimal ? count.toFixed(1) : Math.floor(count)}
      {suffix}
    </span>
  );
};

const LabelSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-section" ref={sectionRef}>
      <div className="stats-inner">
        {statsData.map((stat, index) => (
          <div key={index} className="stat-card" style={{ animationDelay: `${index * 100}ms` }}>
            <div className="stat-icon">{stat.icon}</div>
            <AnimatedNumber
              target={stat.number}
              suffix={stat.suffix}
              isDecimal={stat.isDecimal}
              isVisible={isVisible}
            />
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LabelSection;
